import React from 'react';
import qrcode from 'qrcode-generator';

// ===================== QR บนเอกสาร: สแกนด้วยกล้องมือถือ → เปิดระบบที่ใบนั้น (ฟรี ไม่ต้องติดตั้งแอป) =====================
// ลิงก์ = เว็บระบบ + ?scan=เลขที่เอกสาร · มือถือต้องล็อกอินระบบไว้ก่อน (ครั้งแรกครั้งเดียว)
export const scanUrl = (doc) => `${window.location.origin}/?scan=${encodeURIComponent(doc)}`;

export function qrSvg(text, px = 110) {
  const q = qrcode(0, 'M'); q.addData(text); q.make();
  const n = q.getModuleCount(), m = 2, size = n + m * 2;
  let d = '';
  for (let r = 0; r < n; r += 1) for (let c = 0; c < n; c += 1) if (q.isDark(r, c)) d += `M${c + m} ${r + m}h1v1h-1z`;
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${px}" height="${px}" viewBox="0 0 ${size} ${size}" shape-rendering="crispEdges"><rect width="${size}" height="${size}" fill="#fff"/><path d="${d}" fill="#000"/></svg>`;
}

// QR สำหรับหน้าพิมพ์ (HTML) — เลขที่ใต้รูป
export const qrBlock = (doc, px = 96) => `<div style="text-align:center;font-size:10px;line-height:1.2">${qrSvg(scanUrl(doc), px)}<div>สแกนอัปเดตสถานะ</div></div>`;

// QR บนใบยืม / ใบเบิก (ผู้ใช้ขอ 23/10/2569): สแกน → เปิดใบนั้นในระบบ (?doc=เลขที่ · PrintLog.js DocLinkOpener) → พิมพ์ / ไปบันทึกขั้นต่อไป
export const docUrl = (doc) => `${window.location.origin}/?doc=${encodeURIComponent(doc)}`;
export const qrDocBlock = (doc, px = 66) => `<div style="text-align:center;font-size:9px;line-height:1.1;flex:0 0 auto">${qrSvg(docUrl(doc), px)}<div>สแกนบันทึก</div></div>`;

// QR บนหน้าจอ
export function QrImg({ doc, px = 140 }) {
  return <div style={{ display: 'inline-grid', justifyItems: 'center', gap: 2, fontSize: 11, color: '#64748b' }}>
    <span dangerouslySetInnerHTML={{ __html: qrSvg(scanUrl(doc), px) }} /><span>{doc}</span></div>;
}

// ระยะเวลา (ms) → "1 ชม. 20 น." / "2 วัน 3 ชม."
export const dur = (a, b) => {
  if (!a || !b) return '';
  const min = Math.max(0, Math.round((new Date(b) - new Date(a)) / 60000));
  if (min < 60) return `${min} น.`;
  const h = Math.floor(min / 60), mm = min % 60;
  if (h < 24) return `${h} ชม.${mm ? ` ${mm} น.` : ''}`;
  return `${Math.floor(h / 24)} วัน${h % 24 ? ` ${h % 24} ชม.` : ''}`;
};
export const hm = (t) => (t ? new Intl.DateTimeFormat('th-TH', { timeZone: 'Asia/Bangkok', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(t)) : '');
